<script lang="ts">
    import { Button, Col, Row, ButtonGroup, Label } from 'sveltestrap'
    import Card from "../../Core/Card.svelte";
    import { CheckboxButtonGroup, CheckboxButtonGroupMessage } from '../../../utils/Constant/Constant';
    import data from "../../../Data/ComponentData/Buttons/ButtonsGroup.json"
</script>
  
  <!-- Need to check checked checkbox design -->
<Col sm="12">
    <Card headerTitle={CheckboxButtonGroup} cardBodyprops="btn-group-showcase">
      <div slot="customheader">
        <span>{@html CheckboxButtonGroupMessage}</span>
      </div>
      <div slot="contentbody">
        <Row>
          {#each data.checkboxbutton as buttonData}
            <Col xl="6" sm="12">
              <ButtonGroup>
                {#each buttonData.checkboxdata as buttonItem}
                  <Button color={buttonItem.color} class={buttonItem.class}>
                    <div class="checkbox checkbox-primary">
                      <input
                        id={buttonItem.id}
                        type="checkbox"
                        name={buttonItem.name}
                        value={buttonItem.value}
                        bind:group={buttonItem.group} />
                      <Label for={buttonItem.id}>{buttonItem.title}</Label>
                    </div>
                  </Button>
                {/each}
              </ButtonGroup>
            </Col>
          {/each}
        </Row>
      </div>
    </Card>
</Col>
  